import { FulfillmentGroupPickStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { fgWmsFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import CubeIcon from "@redotech/redo-icons/cube-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgWmsFilterEntries.pickStatus;

export const pickStatusFilterName = entry.name;

export const PickStatusArrayFilter = (): ArrayStringTableFilter<string> => ({
  type: entry.type,
  Icon: CubeIcon,
  operators: entry.operators,
  data: {
    name: pickStatusFilterName,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "pick status",
  itemLabelPlural: "pick statuses",
  display: (item: string) => {
    switch (item) {
      case FulfillmentGroupPickStatus.PICKED:
        return "Picked";
      case FulfillmentGroupPickStatus.PROBLEM:
        return "Problem";
      case FulfillmentGroupPickStatus.IN_PROGRESS:
        return "In progress";
      default:
        return item;
    }
  },
  displayName: entry.displayName,
  values: entry.staticValues,
});
